import { BriefcaseBusiness, CircleUserRound, ClipboardPen, FileText, Home, ListChecks, ShieldCheck, Sparkles } from "lucide-react";

export const WORKSPACE_BASE = "/workspace";

export const WORKSPACE_SECTIONS = [
  { id: "home", path: "home", icon: Home, labelKey: "navHome" },
  { id: "intake", path: "intake", icon: ClipboardPen, labelKey: "navIntake" },
  { id: "business", path: "business", icon: BriefcaseBusiness, labelKey: "navBusiness" },
  { id: "reports", path: "reports", icon: FileText, labelKey: "navReports" },
  { id: "tasks", path: "tasks", icon: ListChecks, labelKey: "navTasks" },
  { id: "services", path: "services", icon: ShieldCheck, labelKey: "navServices" },
  { id: "growth-club", path: "growth-club", icon: CircleUserRound, labelKey: "navGrowthClub" },
  { id: "strategist", path: "strategist", icon: Sparkles, labelKey: "navStrategist" },
];

export const LEGACY_REDIRECTS = [
  { from: "dashboard", to: "home" },
  { from: "chat", to: "intake" },
  { from: "strategy", to: "strategist" },
  { from: "subscription", to: "growth-club" },
];

const SECTION_BY_KEY = {
  dashboard: "home",
  home: "home",
  chat: "intake",
  intake: "intake",
  business: "business",
  reports: "reports",
  files: "files",
  strategy: "strategist",
  strategist: "strategist",
  tasks: "tasks",
  services: "services",
  subscription: "growth-club",
  "growth-club": "growth-club",
};

export function pathForSection(key) {
  return `${WORKSPACE_BASE}/${SECTION_BY_KEY[key] || key}`;
}

export function sectionFromPathname(pathname) {
  const slug = pathname.replace(/^\/workspace\/?/, "").split("/")[0];
  if (slug === "files") return { id: "files", path: "files", labelKey: "files" };
  return WORKSPACE_SECTIONS.find((s) => s.path === slug) || WORKSPACE_SECTIONS[0];
}
